import { render, staticRenderFns } from "./AddNoteForm.vue?vue&type=template&id=c4fa7692&scoped=true&"
import script from "./AddNoteForm.vue?vue&type=script&lang=js&"
export * from "./AddNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./AddNoteForm.vue?vue&type=style&index=0&id=c4fa7692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fa7692",
  null
  
)

component.options.__file = "AddNoteForm.vue"
export default component.exports